export interface BaseRequestContext {
  UserId: string;
  ProductType: null;
  Source: string;
  SearchFilters: null;
}

interface BuildRequestContextParams {
  source: string;
  userId?: string;
}

export const resolveRequestUserId = (userId?: string) => {
  const trimmedUserId = userId?.trim();

  if (trimmedUserId) {
    return trimmedUserId;
  }

  return localStorage.getItem('slotd4') ?? '';
};

export const buildRequestContext = ({ source, userId }: BuildRequestContextParams): BaseRequestContext => ({
  UserId: resolveRequestUserId(userId),
  ProductType: null,
  Source: source,
  SearchFilters: null,
});

export const withRecordId = <TPayload extends BaseRequestContext>(payload: TPayload, recordId: string) => ({
  ...payload,
  RecordId: recordId,
});

export const withSource = <TPayload extends Record<string, unknown>>(payload: TPayload, source: string) => ({
  ...payload,
  source,
});
